import { ElementRef } from '@angular/core';

import { ISnHasHostElement } from '@lib/common/interfaces';
import { mixinDisable, mixinColor, mixinTabIndex } from '@lib/common/mixins';

import { SnButtonType } from '../types/button-type';

class SnBaseButton implements ISnHasHostElement {
  public isLoading: boolean;

  public type: SnButtonType = 'button';

  public readonly hostElement: HTMLElement;

  constructor(elementRef: ElementRef<HTMLElement>) {
    this.hostElement = elementRef.nativeElement;
  }
}

export const SnBaseButtonComponent = mixinTabIndex(mixinDisable(mixinColor(SnBaseButton)));
